import { yup } from '@framework/validation/initYup.ts';
import { isObject } from 'lodash';
import { type ExpressionValue } from '../../evaluate/ExpressionValue.ts';
import { ExpressionType } from '../../IExpression.ts';
import { createExpressionType } from '../../IExpressionType.ts';
import { expressionLogger } from '../../utils/expressionLogger.ts';
import { ReferenceSchema } from '../../validation/ReferenceSchema.ts';
import { type IReferenceExpression } from './IReferenceExpression.ts';

export const ReferenceExpressionType =
  createExpressionType<IReferenceExpression>({
    type: ExpressionType.Reference,
    schema: yup.object({
      type: yup.string().exact(ExpressionType.Reference).required(),
      value: ReferenceSchema.label('Campo di riferimento')
        .default(null)
        .required(),
    }),
    evaluate(expression, scope) {
      const value = scope.getReference(expression.value);

      if (Array.isArray(value) && value.length > 0 && isObject(value[0])) {
        // biome-ignore format: <tbd>
        expressionLogger.warn(`Reference value is an array of objects, be careful in evaluation`, expression, scope);
        return value;
      }

      return value as ExpressionValue;
    },
    getReferences(expression) {
      return [expression.value];
    },
    toString(expression, toString) {
      return `@${expression.value.code}`;
    },
  });
